import React, { useState } from "react";
import FlavoursHero from "./components/FlavoursHero";
import OurChefsAdmin from "./components/OurChefsAdmin";
import MealTypeAdmin from "./components/MealTypeAdmin";
import ExploreMenuAdmin from "./components/ExploreMenuAdmin";


const Flavours = () => {
  // Define tabs for the Flavours admin panel
  const TABS = {
    hero: "FlavoursHero",
    ourChef: "OurChef",
    mealType:"MealType",
    exploreMenu: "ExploreMenu",
    // specials: "FlavoursSpecials",
  };

  // Default to the Hero tab
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Flavours Hero
        </button>
        <button
          onClick={() => handleTabChange(TABS.ourChef)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.ourChef
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Our Chef
        </button>

        <button
          onClick={() => handleTabChange(TABS.mealType)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.mealType
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Meal Type
        </button>
        <button
          onClick={() => handleTabChange(TABS.exploreMenu)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.exploreMenu
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Explore Menu
        </button>
   
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <FlavoursHero />}
        {activeTab === TABS.ourChef && <OurChefsAdmin />}
        {activeTab === TABS.mealType && <MealTypeAdmin />}
        {activeTab === TABS.exploreMenu && <ExploreMenuAdmin />}
        {/* Uncomment the following lines when the components are ready */}
        {/* {activeTab === TABS.gallery && <FlavoursGallery />}
        {activeTab === TABS.specials && <FlavoursSpecials />} */}
      </div>
    </div>
  );
};

export default Flavours;